import { render, staticRenderFns } from "./PRStats.vue?vue&type=template&id=49fa8b3a&scoped=true&"
import script from "./PRStats.vue?vue&type=script&lang=js&"
export * from "./PRStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa8b3a",
  null
  
)

export default component.exports